import React from 'react';

import ActivatedOn from '/component/partial/report/ActivatedOn';
import ClientRole from '/component/partial/report/ClientRole';
import ClientsListHeader from '/component/partial/report/ClientsListHeader';
import PeopleReportDataRenderer from '/component/partial/report/PeopleReportDataRenderer';
import ReportDataProvider from '/component/partial/report/ReportDataProvider';

import {ReportProps} from '../Report.types';

import {generateOnRecordPress} from './NewClientsWithoutOrdersReport.util';
import reportPayload from './reportPayload';

import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';

export const NewClientsWithoutOrdersContent = ({
  loadingData = {total: 0},
  showRecordPopover = () => {},
  recordsShowPopover = () => {},
  recordsShowRecord = () => {},
}: ReportProps) => {
  const {isReadyToLoad, sortParam} = useRecordsSorting({
    recordsName: reportPayload.reportName,
  });

  if (!isReadyToLoad) {
    return null;
  }
  return (
    <ReportDataProvider
      {...reportPayload}
      dataRenderer={PeopleReportDataRenderer}
      dataRendererProps={{
        listHeaderComponent: ClientsListHeader,
        personRoleComponent: ClientRole,
        personInfoComponent: ActivatedOn,
        onRecordPress: generateOnRecordPress({
          showRecordPopover,
          recordsShowPopover,
          recordsShowRecord,
        }),
      }}
      loadingData={loadingData}
      reportParams={[{...sortParam.params}]}
    />
  );
};
